import { render, staticRenderFns } from "./BaseInfoConf.vue?vue&type=template&id=50294d4e&scoped=true&"
import script from "./BaseInfoConf.vue?vue&type=script&lang=js&"
export * from "./BaseInfoConf.vue?vue&type=script&lang=js&"
import style0 from "./BaseInfoConf.vue?vue&type=style&index=0&id=50294d4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50294d4e",
  null
  
)

export default component.exports